// National business / organization registration number, by country.
//
// Not every country has a public org-registration-number concept that a sports
// club would carry, and the term differs per country — so onboarding and the
// settings page only surface the field for countries we have an entry for, and
// label it with the local term (a proper noun, identical in every UI language,
// so it lives here as data rather than in the i18n catalog — same pattern as
// the country / language name tables).
//
// Scoped to SportAdmin's Nordic market for now. Widen the map as we launch
// elsewhere; a country absent from it simply hides the field.

export interface OrgNumberFormat {
  // The local term shown as the field label, e.g. "Organisationsnummer".
  nativeTerm: string;
}

export const orgNumberByCountry: Record<string, OrgNumberFormat> = {
  SE: { nativeTerm: 'Organisationsnummer' },
  NO: { nativeTerm: 'Organisasjonsnummer' },
  DK: { nativeTerm: 'CVR-nummer' },
  FI: { nativeTerm: 'Y-tunnus' },
};

// countryHasOrgNumber reports whether the given ISO 3166-1 alpha-2 country has
// an org-registration-number field we collect. Case-insensitive.
export function countryHasOrgNumber(code: string): boolean {
  return code.toUpperCase() in orgNumberByCountry;
}

// orgNumberTerm returns the local label for the country's org number, or null
// when the country has no such field.
export function orgNumberTerm(code: string): string | null {
  return orgNumberByCountry[code.toUpperCase()]?.nativeTerm ?? null;
}
